import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { first, switchMap } from 'rxjs/operators';
import { CONFIG } from '../dummy/app';
import { observable, action } from 'mobx';
import { Observable, of } from 'rxjs';
import { DataService } from '../services/data.service';
import { pushToObject } from '../services/mapping.service';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  @observable process: boolean = false;
  @observable loading: boolean = true;
  @observable user: any = null;
  @observable profile: any = null;
  @observable selectedTerm: any = null;
  @observable terms: any = null;
  @observable config: any = null;


  authState: any = null;
  user$: Observable<any>;
  constructor(
    private ds: DataService,
    private afAuth: AngularFireAuth,
    private afs: AngularFirestore

    ) {
      this.user$ = this.afAuth.authState.pipe(
        switchMap(user => {
          if (user) {
            this.loading = false;
            return this.afs.doc<any>(`users/${user.uid}`).valueChanges()
          } else {
            this.loading = false;
            return of(null)
          }
        })
      )
    }

  isLoggedIn() {
    return this.afAuth.authState.pipe(first()).toPromise();
  }

  authRef(){
    return this.afAuth.auth
  }
  
  canActive() {
    this.loading = true;
    this.afAuth.user.subscribe(async user => {
      if (user) {
        const { uid } = user;
        this.user = user;
        this.ds.userRef().doc(uid).valueChanges().subscribe(doc => {
          this.profile = doc;
          this.loading = false;
        })
      }
    })
  }

  canActiveRef(){
    return this.afAuth.user
  }

  @action
  async fetchEnvironment() {
    const docs = await this.ds.environmentRef().get().toPromise();
    const config: any = pushToObject(docs);
    this.config = config;
    const {termKey,PROGRAM}=config;
    CONFIG.PROGRAM = PROGRAM
    this.ds.termRef().doc(termKey).valueChanges().subscribe(doc=>{
      this.selectedTerm=doc;
    })
    return config;
  }

  emailSignUp(email: string, password: string) {
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password);
  }

  emailSignIn(email: string, password: string) {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password);
  }

  signOut() {
    return this.afAuth.auth.signOut();
  }

}
